var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-total wh-flex-center",style:({color: _vm.color,width: `${_vm.size}px`,height: `${_vm.size}px`})},[_c('span',{staticClass:"total-num"},[_vm._v(_vm._s(_vm.num))]),_c('span',{staticClass:"total-txt"},[_vm._v(_vm._s(_vm.txt))])])
}
var staticRenderFns = []

export { render, staticRenderFns }